export interface IWidgetToHostMessage {
    type:
        | 'widget-style'
        | 'widget-initialization'
        | 'widget-error'
        | 'widget-payload'
        | 'widget-focus'
        | 'widget-credentials-request'
        | 'widget-creditcard-redirect';
}

export function isIWidgetToHostMessage(
    message: any
): message is IWidgetToHostMessage {
    return [
        'widget-style',
        'widget-initialization',
        'widget-error',
        'widget-payload',
        'widget-focus',
        'widget-credentials-request',
        'widget-creditcard-redirect'
    ].includes(message.type);
}

export interface IWidgetStyleMessage extends IWidgetToHostMessage {
    type: 'widget-style';
    data: {
        height: number;
    };
}

export interface IWidgetCreditCardRedirectMessage extends IWidgetToHostMessage {
    type: 'widget-creditcard-redirect';
    data: {
        balanceSelected: boolean;
    };
}

export interface IWidgetInitializationMessage extends IWidgetToHostMessage {
    type: 'widget-initialization';
}

export interface IWidgetErrorMessage extends IWidgetToHostMessage {
    type: 'widget-error';
    data: {
        errorType: 'API' | 'Runtime' | 'Configuration' | 'Network';
        message: string;
        details: any;
    };
}

export interface IWidgetPayloadMessage extends IWidgetToHostMessage {
    type: 'widget-payload';
    data: IWidgetPayload;
}

export interface IWidgetPayload {
    useBalance: boolean;
    fundSourceType: number;
    fundSourceId: number;
    fundSourceAmount: number;
    topupAmount: number;
    fundSourceCanBeAutobilled: boolean;
    requestId?: number;
}

export interface IWidgetFocusMessage extends IWidgetToHostMessage {
    type: 'widget-focus';
}

export interface IWidgetCredentialsRequestMessage extends IWidgetToHostMessage {
    type: 'widget-credentials-request';
}
